import FormTemplate from "@Common/FormTemplate";
import OfferForm from "@Common/OfferForm";

import { getSqlServerGuidHash, sendMetric, randomNumber, getWhatId, clearParamWithoutRerender, getAbTestMetrika, fixOrphans } from "@utils";
import dayjs from "dayjs";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";

import prize from "./img/gift_icon.gif";
import Timer from "../../../Modal/PromoModal/Default/Timer";

import DefaultListItemAccordion from "../../Default/ListItemAccordion/Default";
import Arrow from "../img/arrow_black.svg";
import copyArrowBtnDark from "../img/arrow_btn.svg";
import copyDark from "../img/copy_dark.svg";
import copyGrey from "../img/copy_grey.svg";

import hearth from "../img/hearth.png";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const ListItemAccordionSberPrime = inject("mainStore")(
    observer(({ mainStore, item, isAccordionOpen, setIsAccordionOpen, handleClick = () => {}, typeLabel = "", cover }) => {
        const abTest = computed(() => mainStore.getMainStore("abTest")).get();
        const abTestMetika = computed(() => mainStore.getMainStore("abTestMetika")).get();
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const wdm = mainStore.getMainStore("codeWdm");
        const wd_mc = mainStore.getMainStore("codeWdMc");

        const [number, setNumber] = useState(5942);
        const [stateAnswer, setStateAnswer] = useState(0);
        const [open, setOpen] = useState(false);
        const [copyText, setCopyText] = useState(false);
        const [time, setTime] = useState("10:03");
        const [percentNumber, setPercentNumber] = useState(10);
        const [openDisclaimer, setOpenDisclaimer] = useState(false);

        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, item?._id);

        const termsOfUse =
            item && item.offerDetail && item.offerDetail?.termsOfUse ? item.offerDetail?.termsOfUse.replace(/{{dateEnd}}/gim, dayjs(item.dateEnd).format("DD.MM.YYYY")).replace(/{{dateStart}}/gim, dayjs(item.dateStart).format("DD.MM.YYYY")) : "";

        useEffect(() => {
            if (isAccordionOpen._id === item._id) {
                let el = document.getElementById(`${isAccordionOpen._id}`);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        }, [isAccordionOpen]);

        useEffect(() => {
            let body = document.body;
            if (body && openDisclaimer) {
                body.style.overflow = "hidden";
                body.style["touch-action"] = "none";
                body.style["-webkit-overflow-scrolling"] = "none";
                body.style["overscroll-behavior"] = "none";
                body.style.width = "100%";
            } else {
                body.style = {};
            }
        }, [openDisclaimer]);

        useEffect(() => {
            if (localStorage.getItem(item._id)) {
                setNumber(parseInt(localStorage.getItem(item._id)));
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);
            } else {
                let num = randomNumber(5000, 25000);
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);

                localStorage.setItem(item._id, num);
                setNumber(num);
            }
        }, []);

        const handleOpen = () => {
            setOpen(!open);

            if (!open) {
                sendMetric(`click_offer_details`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: item._id,
                    params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                    params4: item?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: `${what_id}`,
                });
            }
        };

        const handleCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            sendMetric(`click_offer_accepted_copy_code`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: `${what_id}`,
            });

            navigator.clipboard.writeText(item.promoCode).then(() => {
                setCopyText("Скопирован в буфер");
                setTimeout(() => {
                    setCopyText(false);
                }, 1000);
            });
        };

        const clickBtnCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            navigator.clipboard.writeText(item.promoCode).then(() => {
                setTimeout(() => {
                    if (!localStorage.getItem("first_click_offer_go_to_site")) {
                        sendMetric(`first_click_offer_go_to_site`, {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: item._id,
                            params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                            params4: item?.code,
                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                            params7: null,
                            params8: `${what_id}`,
                        });

                        localStorage.setItem("first_click_offer_go_to_site", true);
                    }

                    sendMetric(`click_offer_accepted_copy_code_go_to_site`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: item._id,
                        params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                        params4: item?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: `${what_id}`,
                    });

                    if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                        window.risMetrika.reachgoal_ch({
                            event: "click_offer_accepted_copy_code_go_to_site",
                            siteId: what_id, //'id витрины',
                            offerId: item?._id, //'id оффера'
                            variantCode: item?._ab_code, //'в оффере новый ключ _ab_code',
                            position: item?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                            sort: item?.sortNum, //'Сортировка оффера на витрине!!!' ,
                            session_uuid: localStorage.getItem("_r_p_s"),
                            widget_code: wdCd ? wdCd : "",
                            ml_traffic_mode: wdm ? wdm : "",
                            ml_model_code: wd_mc ? wd_mc : "",
                        });
                    }

                    const hrefOut = item && item.activationLink ? item.activationLink : false;

                    if (hrefOut) {
                        const a = document.createElement("a");
                        a.href = hrefOut;
                        a.target = "_blank";
                        a.click();
                        a.remove();
                    }
                }, 500);
            });
        };

        const clickBtn = (e) => {
            e.stopPropagation();
            e.preventDefault();
            if (!localStorage.getItem("first_click_offer_go_to_site")) {
                sendMetric(`first_click_offer_go_to_site`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: item._id,
                    params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                    params4: item?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: `${what_id}`,
                });
                localStorage.setItem("first_click_offer_go_to_site", true);
            }

            sendMetric(`click_offer_accepted_go_to_site`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: `${what_id}`,
            });
            const hrefOut = item && item.activationLink ? item.activationLink : false;

            if (hrefOut) {
                const a = document.createElement("a");
                a.href = hrefOut;
                a.target = "_blank";
                a.click();
                a.remove();
            }
        };

        const handleInstruction = () => {
            sendMetric("click_instruction_offer", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: `Клик на инструкцию по активации"`,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?._id,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const handleClickGhost = () => {
            setIsAccordionOpen(false);
            clearParamWithoutRerender(["id", "code"]);

            sendMetric("click_offer_button_ghost_exit", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const closeAccordionWithClear = () => {
            setIsAccordionOpen(false);
            clearParamWithoutRerender(["id", "code"]);
        };

        return (
            <div className={`ab-4031-v2 list-item__accordion hit`} id={item._id}>
                <div
                    className="list-item__accordion__content"
                    onClick={() => {
                        handleClick();
                        setStateAnswer(0);
                        setOpenDisclaimer(false);
                    }}
                >
                    <div className="list-item__accordion__logo">
                        <img alt="logo_mobile" src={cover} />
                        <div className="list-item__accordion__title-container">
                            <span className={`list-item__accordion__title ${isAccordionOpen._id === item._id ? "big" : ""}`} dangerouslySetInnerHTML={{ __html: fixOrphans(item.title) }} />
                        </div>
                    </div>

                    <span className={`list-item__accordion__hit-label_block hit`}>{typeLabel}</span>

                    <img alt="hearth" className="list-item__accordion__sber-hearth" src={hearth} />
                </div>

                {isAccordionOpen._id === item._id ? (
                    item.promoCode ? (
                        item.ghostOffer ? (
                            <div className={`content-promo`}>
                                <div className="content-promo__text">
                                    <span className="title">
                                        {item?.ghostOfferConfig && item.ghostOfferConfig.textAnswer ? item.ghostOfferConfig.textAnswer : "Как только предложение станет доступным, мы направим уведомление  на указанную Вами почту "}
                                    </span>
                                    <div className={`content-promo__button-close`} onClick={() => handleClickGhost()}>
                                        Выбрать другое предложение
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className={`content-promo`}>
                                <div className="content-promo__progressbar">
                                    <div className="content-promo__progressbar-header">
                                        <img alt="content-promo__progressbar-header" src={prize} />
                                        <span className="content-promo__progressbar-text">Активируйте предложение!</span>
                                        <span className="content-promo__progressbar-value" style={{ color: "#19B677" }}>
                                            {100}%
                                        </span>
                                    </div>
                                    <div className="content-promo__progressbar-line">
                                        <div className="line__filling" style={{ width: `100%` }}></div>
                                    </div>
                                </div>

                                {item?.offerType && !["partnerlink", "leads"].includes(item.offerType) ? (
                                    <div className={`content-promo__code ${copyText ? "copy" : ""}`} onClick={(e) => handleCopy(e)}>
                                        {copyText ? `${copyText}` : `${item.promoCode}`}
                                        <img alt="content-promo__code" src={copyText ? copyGrey : copyDark} />
                                    </div>
                                ) : null}

                                {item.offerType !== "leads" ? (
                                    <div className="content-promo__copy" id="button_copy" onClick={item?.offerType !== "partnerlink" ? (e) => clickBtnCopy(e) : (e) => clickBtn(e)}>
                                        {item?.offerType !== "partnerlink" && item._id !== "662b6b30d07bd4eb3685f19b" && item._id !== "65af6c1623f7b941440758ec" ? "Скопировать и перейти на сайт" : "Перейти на сайт"}
                                        <img alt="content-promo__copy" src={copyArrowBtnDark} width={21} />
                                    </div>
                                ) : (
                                    <span className="content-promo__text">
                                        <span>Спасибо за вашу заявку!</span>
                                        <span>Наш менеджер скоро с вами свяжется</span>
                                    </span>
                                )}
                                {item.offerType === "leads" ? null : (
                                    <div className="content-promo__timer">
                                        <span>Успейте активировать:</span>
                                        <Timer endDate={dayjs().local()} />
                                    </div>
                                )}

                                {!item.activationLink.length ? (
                                    <div className={`content-promo__button-close`} onClick={closeAccordionWithClear}>
                                        Выбрать еще предложения
                                    </div>
                                ) : null}
                                {item?.offerDetail?.miniDisc ? <div className="content-promo__instructions" onClick={handleInstruction} dangerouslySetInnerHTML={{ __html: item?.offerDetail.miniDisc }}></div> : null}
                                <div className="content-promo__button" id="close_accordion" onClick={closeAccordionWithClear}>
                                    <span>Скрыть предложение</span> <img alt="content-promo__button" src={Arrow} />
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="content-offer">
                            {isAccordionOpen.formTemplate && stateAnswer < isAccordionOpen.formTemplate?.length ? (
                                <div className="content-offer__form">
                                    {isAccordionOpen.formTemplate?.map((el, index) =>
                                        stateAnswer === index ? (
                                            <FormTemplate
                                                type={el.restrictionType}
                                                item={el}
                                                key={index}
                                                stateAnswer={stateAnswer}
                                                setStateAnswer={setStateAnswer}
                                                formTemplate={isAccordionOpen.formTemplate}
                                                offerId={item._id}
                                                surveyId={isAccordionOpen.surveyId}
                                                vendorId={item.vendor._id}
                                                index={index}
                                                promo={item}
                                                setIsAccordionOpen={setIsAccordionOpen}
                                                id={item.id}
                                                setPercentNumber={setPercentNumber}
                                                percentNumber={percentNumber}
                                                time={time}
                                                number={number}
                                            />
                                        ) : null,
                                    )}
                                </div>
                            ) : (
                                <OfferForm offerItem={isAccordionOpen} setIsAccordionOpen={setIsAccordionOpen} setPercentNumber={setPercentNumber} percentNumber={percentNumber} time={time} number={number} />
                            )}

                            {item.ghostOffer ? null : <div className="content-offer__description" dangerouslySetInnerHTML={{ __html: item.description }}></div>}

                            {item.ghostOffer ? null : (
                                <div className="content-offer__details-btn" onClick={(e) => handleOpen(e)}>
                                    <span>{open ? "Скрыть" : "Подробное описание"}</span>
                                    <img alt="content-offer__details-btn" src={Arrow} style={!open ? { transform: "rotate(180deg)" } : {}} />
                                </div>
                            )}

                            {item.ghostOffer ? null : open ? (
                                <div className={`content-offer__info ${open ? "open" : ""}`}>
                                    <div className={`content-offer__info-activate `} dangerouslySetInnerHTML={{ __html: item?.offerDetail?.howToActivate || "" }}></div>
                                    <div className={`content-offer__info-details `}>
                                        <div className="container__all-conditions_text" dangerouslySetInnerHTML={{ __html: termsOfUse }}></div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )
                ) : null}
            </div>
        );
    }),
);

const ListItemAccordion = ({ isSberPrime = false, ...props }) => {
    if (!isSberPrime) {
        return <DefaultListItemAccordion {...props} />;
    }

    return <ListItemAccordionSberPrime {...props} />;
};

export default ListItemAccordion;
